import React from 'react';
import { Box, Typography, Card, CardContent, CardActionArea, Chip } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';

const VISIBILITY_CONFIG = {
  'public': { label: 'Pública', color: '#4caf50', bg: '#e8f5e9' },
  'protected': { label: 'Protegida', color: '#1976d2', bg: '#e3f2fd' },
  'private': { label: 'Privada', color: '#757575', bg: '#f5f5f5' },
};

const STATUS_CONFIG = {
  'Published': { label: 'Publicada', color: '#4caf50' },
  'Draft': { label: 'Rascunho', color: '#ff9800' },
  'Under Review': { label: 'Em Revisão', color: '#2196f3' },
  'Approved': { label: 'Aprovada', color: '#8bc34a' },
  'Archived': { label: 'Arquivada', color: '#757575' },
};

/**
 * PolicyCard - Policy summary card with visibility indicator
 * @param {string} name - Policy name
 * @param {string} version - Policy version
 * @param {string} status - Policy status (Published, Draft, Under Review, Approved, Archived)
 * @param {string} visibility - Visibility level (public, protected, private)
 * @param {string} lastUpdated - Last update date
 * @param {function} onClick - Optional click handler
 */
export const PolicyCard = ({
  name,
  version,
  status,
  visibility,
  lastUpdated,
  onClick,
}) => {
  const visConfig = VISIBILITY_CONFIG[visibility] || VISIBILITY_CONFIG['private'];
  const statusConfig = STATUS_CONFIG[status] || STATUS_CONFIG['Draft'];
  const CardWrapper = onClick ? CardActionArea : Box;

  return (
    <Card
      elevation={0}
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        transition: 'box-shadow 0.2s',
        '&:hover': onClick ? { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' } : {},
      }}
    >
      <CardWrapper onClick={onClick}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
            <DescriptionIcon sx={{ color: '#1976d2', mt: 0.5 }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                {name}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                <Chip
                  label={visConfig.label}
                  size="small"
                  sx={{
                    bgcolor: visConfig.bg,
                    color: visConfig.color,
                    fontWeight: 500,
                    fontSize: '0.7rem',
                  }}
                />
                <Typography variant="caption" color="text.secondary">
                  Versão {version}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {statusConfig.label}
                </Typography>
              </Box>
              {lastUpdated && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  Atualizado em {lastUpdated}
                </Typography>
              )}
            </Box>
          </Box>
        </CardContent>
      </CardWrapper>
    </Card>
  );
};
